import { auth } from "./config";

// Ghost UID state — persisted in sessionStorage so it survives page reloads
// but clears when the browser tab is closed
let ghostUid = sessionStorage.getItem('ghostUid') || null;
let ghostEmail = sessionStorage.getItem('ghostEmail') || null;

export const setGhostUid = (uid, email) => {
    ghostUid = uid;
    ghostEmail = email || null;
    sessionStorage.setItem('ghostUid', uid);
    if (email) sessionStorage.setItem('ghostEmail', email);
};

export const clearGhostUid = () => {
    ghostUid = null;
    ghostEmail = null;
    sessionStorage.removeItem('ghostUid');
    sessionStorage.removeItem('ghostEmail');
};

export const getGhostUid = () => ghostUid;
export const getGhostEmail = () => ghostEmail;
export const isGhostMode = () => !!ghostUid;

export const getEffectiveUid = () => ghostUid || auth().currentUser.uid;
